// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.condensed[data-v-5c5e80d8] {\n    padding: 0.25rem 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
